import { api_POST, api_PUT, api_GET, api_GETExternal } from "services/api_service.js";
import { showMessage } from "./message";

export const EnviaProtocoloWithProtocoloGerador = (json, callback) => {
    if (json.protocolo_Id == 0) {
        api_POST('protocoloGerador/PostProtocoloWithProtocoloGerador', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('protocoloGerador/PutProtocoloWithProtocoloGerador', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaProtocoloGeradorCaracterizacaoResiduo = (json, callback) => {
    api_POST('protocoloGerador/PostProtocoloGeradorCaracterizacaoResiduo ', json)
        .then(result => { callback(result) })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}

export const EnviaProtocoloGeradorLocal = (json, callback) => {
    if (json.protocoloGeradorLocal_Id == 0) {
        api_POST('protocoloGerador/PostProtocoloGeradorLocal', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('protocoloGerador/PutProtocoloGeradorLocal', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaProtocoloGeradorLocalArmazenagem = (json, callback) => {
    if (json.protocoloGeradorLocalArmazenagem_Id == 0) {
        api_POST('protocoloGerador/PostProtocoloGeradorLocalArmazenagem', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('protocoloGerador/PutProtocoloGeradorLocalArmazenagem', json)
            .then(result => { callback(result) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaProtocoloGeradorClasseResiduo = (json, callback) => {
    if (json.protocoloGeradorClasseResiduo_Id == 0) {
        api_POST('protocoloGerador/PostProtocoloGeradorClasseResiduo', json).then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('protocoloGerador/PutProtocoloGeradorClasseResiduo', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaProtocoloDocumentoGerador = (json, callback) => {
    api_POST('protocoloGerador/PostProtocoloDocumento', json)
        .then(result => { callback(result); })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}


export const EnviaRequerimentoGerador = (json, callback) => {
    if (json.requerimentoGerador_Id == 0) {
        api_POST('RequerimentoGerador/PostRequerimentoGerador', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('RequerimentoGerador/PutRequerimentoGerador', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaRequerimentoGeradorCaracterizacaoResiduo = (json, callback) => {
    api_POST('requerimentoGerador/PostRequerimentoGeradorCaracterizacaoResiduo ', json)
        .then(result => { callback(result); })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}

export const EnviaRequerimentoGeradorLocal = (json, callback) => {
    if (json.requerimentoGeradorLocal_Id == 0) {
        api_POST('requerimentoGerador/PostRequerimentoGeradorLocal ', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('requerimentoGerador/PutRequerimentoGeradorLocal', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaRequerimentoGeradorLocalArmazenagem = (json, callback) => {
    if (json.requerimentoGeradorLocalArmazenagem_Id == 0) {
        api_POST('requerimentoGerador/PostRequerimentoGeradorLocalArmazenagem ', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('requerimentoGerador/PutRequerimentoGeradorLocalArmazenagem', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaRequerimentoGeradorClasseResiduo = (json, callback) => {
    if (json.requerimentoGeradorClasseResiduo_Id == 0) {
        api_POST('requerimentoGerador/PostRequerimentoGeradorClasseResiduo ', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
    else {
        api_PUT('requerimentoGerador/PutRequerimentoGeradorClasseResiduo', json)
            .then(result => { callback(result); })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }
}

export const EnviaRequerimentoDocumentoGerador = (json, callback) => {
    api_POST('requerimento/PostrequerimentoDocumento', json)
        .then(result => { callback(result); })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}

